import { ContainerModule } from 'inversify';
import IdVerificationRepository from 'src/features/verification/data/IdVerificationRepository';
import IdVerificationService from 'src/features/verification/data/service/idVerificationService';
import { idVerificationServiceInterface } from 'src/features/verification/data/service/idVerificationService.types';
import { IdVerificationRepositoryInterface } from 'src/features/verification/domain/IdVerificationRepositoryInterface';
import GetIdVerificationSessionUseCase from 'src/features/verification/domain/useCases/GetIdVerificationSessionUseCase';
import GetIdVerificationStatusUseCase from 'src/features/verification/domain/useCases/GetIdVerificationStatusUseCase';

export const idVerificationBindings = new ContainerModule((bind) => {
  // Services
  bind<idVerificationServiceInterface>(IdVerificationService).to(
    IdVerificationService
  );

  // Repositories
  bind<IdVerificationRepositoryInterface>(IdVerificationRepository).to(
    IdVerificationRepository
  );

  // Use cases
  bind<GetIdVerificationSessionUseCase>(GetIdVerificationSessionUseCase).to(
    GetIdVerificationSessionUseCase
  );
  bind<GetIdVerificationStatusUseCase>(GetIdVerificationStatusUseCase).to(
    GetIdVerificationStatusUseCase
  );
});
